import type { BrebQrPayTranslations } from "../interfaces/brebQrPay";

export const brebQrPayTranslations: BrebQrPayTranslations = {
  scan_button: "Escanear QR",
  scan_not_breb: "Ese código no es un QR Bre-B.",
  scan_image_no_qr: "No encontramos un código QR en la imagen.",
  scan_image_failed: "No pudimos leer la imagen. Prueba con otra.",

  camera_title: "Escanea el QR Bre-B",
  camera_hint: "Centra el código dentro del recuadro",
  camera_close: "Cerrar cámara",
  camera_starting: "Abriendo la cámara…",
  camera_foreign_qr: "Ese código no es un QR Bre-B",
  camera_torch_on: "Linterna",
  camera_torch_off: "Apagar linterna",
  camera_upload: "Subir imagen",
  camera_retry: "Reintentar",
  camera_denied_title: "No hay permiso para usar la cámara",
  camera_denied_text:
    "Permite el acceso a la cámara en la configuración del navegador y reintenta, o sube una imagen del QR.",
  camera_not_found: "No encontramos una cámara en este dispositivo. Sube una imagen del QR.",
  camera_in_use: "Otra aplicación está usando la cámara. Ciérrala y reintenta.",
  camera_insecure: "La cámara solo funciona en una conexión segura (HTTPS).",
  camera_unsupported: "Este navegador no permite usar la cámara. Sube una imagen del QR.",
  camera_error: "No pudimos abrir la cámara.",

  resolving: "Verificando el código…",
  resolve_invalid_title: "QR inválido",
  resolve_invalid_text: "No pudimos leer este código como un QR Bre-B. Escanéalo de nuevo o pide otro.",
  resolve_key_not_found_title: "Llave inválida",
  resolve_key_not_found_text: "La llave de este QR no existe o está inactiva. Pide un código nuevo.",
  resolve_unavailable_title: "No pudimos verificar el código",
  resolve_unavailable_text: "Revisa tu conexión e intenta de nuevo.",
  resolve_access_denied_title: "No tienes acceso",
  resolve_access_denied_text: "Tu usuario no tiene permiso para consultar pagos.",
  resolve_unsupported_title: "QR no soportado",
  resolve_unsupported_text:
    "Por ahora no puedes pagar este QR desde Coloca. Usa otro medio de pago en el comercio.",
  resolve_retry: "Reintentar",
  resolve_scan_another: "Escanear otro código",
  qr_clear: "Quitar QR",

  payee_label: "Vas a pagar a",
  payee_merchant: "Comercio",
  payee_person: "Persona",
  payee_bank: "Banco",
  payee_key: "Llave",
  payee_document: "Documento",
  payee_reference: "Referencia",
  payee_inactive: "La llave no está activa (estado: {{status}}). No se le puede pagar.",

  amount_fixed_hint: "Lo define el código y no se puede cambiar. La comisión se suma a este valor.",

  block_amount_mismatch: "No es posible pagar exactamente este valor. Escanea el código de nuevo.",
  resolve_not_enabled_title: "Pagar con QR no está disponible",
  resolve_not_enabled_text: "Por ahora tu organización no puede pagar QR desde Coloca.",
};
